import React from 'react';
import Table from 'react-bootstrap/Table';
import { useNavigate,Link } from "react-router-dom";
import { Base64 } from 'js-base64';
//import Swal from '../../../node_modules/sweetalert2/dist/sweetalert2';
import Swal from '../../messageBox/customSweetAlert';
import { DELETE_VEHICLE } from '../../constant'; 
import { useDispatch, useSelector } from 'react-redux';
import { setLoading } from '../../redux/loaderAction';
import axios from 'axios';
import {dateFormat} from "../../utils";

function VehicleTable({tableData,setTabelData,questionList}) {
  //console.log('VehicleTable',tableData);
    const dispatch = useDispatch();
    const navigate = useNavigate();
   const handleEditClick=(id)=>{ 
    
    navigate(`/home/vehicle/edit/${id}`);
   }
   const getFirstAnswer = (component) => {
    let components;
    try {
    
      const parsedOnce = JSON.parse(component);
                        components = typeof parsedOnce === 'string'
                          ? JSON.parse(parsedOnce)
                          : parsedOnce;

    // const components = JSON.parse(
    //   typeof component === 'string' ? JSON.parse(component) : component
    // );
    const failedComponents = components.filter(c => c.answer === '2' || c.answer === '3');

    if (failedComponents.length === 0) {
      return <span>Good Condition</span>;
    }

    return (
      <div style={{ textAlign: 'left' }}>
        {failedComponents.map((c, idx) => (
          <div key={idx} style={{ marginBottom: '4px' }}>
            <span>
              {(questionList[c.questionId - 1]?.check_list) || `Question ${c.questionId}`} –{' '}
            </span>
            <span style={{ color: 'red', fontSize: '13px' }}>
              {c.answer === '2' ? 'Requires Attention' : 'Needs Repair'}
            </span>
          </div>
        ))}
      </div>
    );
  } catch (err) {
    console.error('Error parsing component:', err);
    //return <span style={{ color: 'gray' }}>Invalid Data</span>;
    return <span>Good Condition</span>;
  }
  }

  const handleDeleteClick = (id) =>{
Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this item!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(setLoading(true));
          axios.post(DELETE_VEHICLE + '/' + `${id}`)
          .then((response)=>{
              if(response.data.status === '200'){
                dispatch(setLoading(false));
                  Swal.fire({
                    title: 'Success!',
                    text: response.data.message,
                    icon: 'success',
                    confirmButtonText: 'OK',
                    allowOutsideClick: false,
                  });
                  //setIsReload(prev => !prev);
                  const updatedTableData = tableData.filter((item) => item.vehicle_id !== id);
                      setTabelData(updatedTableData);
              }else{
                dispatch(setLoading(false));
                Swal.fire({
                  title: 'Failed!',
                  text: response.data.message,
                  icon: 'Error',
                  confirmButtonText: 'OK',
                  allowOutsideClick: false,
                });
              }
              //console.log(response);
          }).catch(error => {
            dispatch(setLoading(false));
              Swal.fire({
                  title: 'Failed!',
                  text: error.message,
                  icon: 'Error',
                  confirmButtonText: 'OK',
                  allowOutsideClick: false,
                });
            })
          //alert(userId);
          
        
      }
    });
  }

  return (
    <Table striped bordered hover className='tbl-require'>
        <thead>
            <tr>
                <th>#</th>
                <th>Vehicle Name</th>
                <th>Vehicle Model</th>
                <th>Model Year</th>
                <th>Vehicle Condition</th>
                <th>Updated Date</th>
                 <th>Checklist Report</th>
                <th style={{textAlign:'center'}}>Action</th>
            </tr>
        </thead>
        <tbody>
            {tableData && tableData.map((details,index)=>(
                <tr key={index}>
                    <td>{index+1}</td>
                    <td>{details.vehicle_name}</td>
                    <td> {details.vehicle_model }</td>
                    <td>{details.model_year}</td>
                   
                   <td>{getFirstAnswer(details.inspectionCheckLists[0]?.component)}</td>
                   <td>{
                    details.inspectionCheckLists[0]?.inspection_date ?
                   dateFormat(details.inspectionCheckLists[0]?.inspection_date) :
                   <span style={{color:'gray'}}>N/A</span>
                   }</td>
                    <td>
                      {
                        details.inspectionCheckLists[0]?.inspection_date ?
                         <Link  to={`/home/vehicle/report?vehicleName=${Base64.encode(details.vehicle_name)}&vehicleId=${Base64.encode(details.vehicle_id)}`}>View Report</Link>
                     
                        : <span style={{color:'gray'}}>N/A</span>
              }
                     </td>
                    <td style={{textAlign:'center',cursor:'pointer'}}>
                        <i className="pi pi-pen-to-square icon-btn-edit" onClick={() => handleEditClick(details.vehicle_id)}></i>
                        <i className="pi pi-trash icon-btn-delete" onClick={()=>handleDeleteClick(details.vehicle_id)}></i>
                       <a href={`/home/vehicle/view/id?vehicleId=${Base64.encode(details.vehicle_id)}`} // Replace with the correct route
                                    target="_blank" // Open in a new tab
                                     onClick={() => localStorage.setItem('activeMenu', 'Vehicle List')} 
                                    rel="noopener noreferrer" // Security best practice
                                   style={{ textDecoration: 'none', color: 'rgb(49, 135, 111)',display: 'none' }} // Inherit color and remove underline
                                  >
                        <i className="pi pi-eye icon-btn-view"></i>
                   </a>
                    </td>
                </tr>
            )) }  
        </tbody>
    </Table>
  )
}

export default VehicleTable